export default __webpack_public_path__ + "public/assets/images/fc41bfb6e216b891e439f4d99411c0eb.png";